export const footerElements = () => ({
    footer: document.querySelector('footer'),
    body: document.querySelector('body')
});
